import type { Move } from '../../../schemas/move';

/**
 * ***Infanzia Complessa*** — mossa comune disponibile **esattamente al
 * 2° livello** (manuale V1 r. 1787).
 *
 * Effetto: il PG sceglie un **secondo archetipo** tra quelli della propria
 * classe. Conseguenze cross-field (gestite da `applyLevelUp`):
 *  - aggiunge la mossa archetipo del 2° archetipo a `Character.moves`
 *    (via `startingChoiceGroups` con `requiresArchetype` sulla classe del PG)
 *  - estende l'accesso a spell con `requiresArchetype` sul nuovo archetipo
 *    (es. Chierico-Nano sblocca *Voce della Terra*)
 *  - applica `baseHpOverride` se il 2° archetipo lo definisce (FI-1 esteso:
 *    proprietà della combo classe+archetipo, non legata alla creazione).
 *    Caso noto: Paladino-Umano L1 → IC Nano L2 → HP `12 + COS` invece di
 *    `10 + COS` (delta +2 a `hp.max` e `hp.current`).
 *
 * **NB**: la disponibilità «esattamente al 2° livello» NON è espressa via
 * `prerequisites` (sintassi non sufficiente) ma è enforced dal predicate
 * `getAvailableCommonMoves` in `services/levelUp.ts`: la mossa appare nel
 * pool solo se `targetLevel === 2 && character.secondaryArchetypeId === undefined`.
 *
 * Riferimenti: `dev-workspace/docs/Fase-D-Level-Up-SSOT.md` §1.5.
 */
export const infanziaComplessa: Move = {
  id: 'common.infanzia-complessa',
  name: 'Infanzia Complessa',
  type: 'common',
  // `classId` undefined: la mossa non appartiene a una classe specifica.
  trigger: 'Quando raggiungi esattamente il 2° livello',
  description:
    'Scegli un secondo archetipo tra quelli della tua classe. Ottieni le sue caratteristiche meccaniche (eventuale `baseHpOverride`, mossa archetipo iniziale, accessi a spell condizionati ad archetipo).',
  tags: [],
  prerequisites: [],
  replaces: [],
};
